/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
*/

// Bootstrap requires
require('./vendor/bootstrap-requires.js');



// Optional Vendor Requires
require('./vendor/iframeResizer.min.js');
// require('./vendor/imagesloaded.pkgd.min.js');
require('./vendor/jquery.actual.min');
// require('./vendor/jquery.validate.min');
// require('./vendor/object-visual-lock');
// require('./vendor/js.cookie');
// require('./vendor/youtube-iframe-assistant');

// ScrollTrigger
require('./app/scrollTrigger');

// App Requires
// require('./app/config');
// require('./app/helpers');
require('./app/iframes');
require('./app/image-swap');
require('./app/primary-navigation');
require('./app/sliders');
require('./app/video-player');
// require('./app/popover');
require('./app/forms');
require('./app/blocks/icon-info-grid');
require('./app/blocks/two-column-image');
require('./app/blocks/value-calculator');
require('./app/gridder-setup');
